// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"514":"5217e025","663":"a5ad161a"}[chunkId] + ".chunk.css";
};